var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9969 0.00358453L12.0032 0H11.9905L11.9969 0.00358453ZM11.9969 0.00358453L9.46146 1.43637L2.54171 5.34305L0 6.7794V9.63975V17.4159V20.2763L2.54171 21.7003L9.46783 25.576L12.0096 27L14.5512 25.5636L21.4584 21.657L24 20.2267V17.3664V9.58404V6.72369L21.4584 5.29971L14.5321 1.42398L11.9969 0.00358453ZM18.9293 9.59641L12.0032 5.7207L5.09612 9.62737V17.4097L12.0222 21.2793L18.9293 17.3788V9.59641Z",
    fill: "#375BD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a50883e2ab798b72ba4cd6fdc02ca575.svg";
export { ForwardRef as ReactComponent };